import { useQuery } from '@tanstack/react-query'
import { tenantApi } from './api'

// Vineyard mode (§55.20) — a per-tenant display preference. When on, the UI
// relabels "Variety" → "Vine variety" and surfaces trellis + row/vine spacing on
// blocks. Reuses the shared ['tenant-profile'] query cache (Settings, Farm Map),
// so this is a cheap read everywhere it's needed.
export function useVineyardMode(): boolean {
  const { data } = useQuery({
    queryKey: ['tenant-profile'],
    queryFn: () => tenantApi.get().then(r => r.data),
    staleTime: 5 * 60 * 1000,
  })
  return !!data?.vineyard_mode
}
